/** @format */

import moment from 'moment';

/**
 * Días de retiro lun–sáb con corte 14:00 (lun–vie) / 12:00 (sáb).
 * Antes del corte → hoy; después → siguiente día disponible.
 */
export const getPickupAvailableDays = ({ specialSchedule = [], regularSchedule = [], count = 7 } = {}) => {
	const closedSet = {};

	for (let s = 0; s < specialSchedule.length; s++) {
		const sch = specialSchedule[s];
		if (!sch?.applies_to_days?.length) continue;
		if (!sch.reason?.includes('Cerrado')) continue;

		const startDay = moment.unix(sch.start).utc().startOf('day');
		const endDay = moment.unix(sch.end).utc().startOf('day');

		for (let d = moment(startDay); d.diff(endDay) <= 0; d.add(1, 'days')) {
			closedSet[d.format('DD/MM/YYYY')] = true;
		}
	}

	const closedWeekdays = new Set();
	regularSchedule.forEach((r) => {
		if (typeof r.open === 'string' && r.open.toUpperCase() === 'CERRADO') {
			closedWeekdays.add(Number(r.day));
		}
	});

	const isPickupOpenDay = (dayMoment) => {
		const formatted = dayMoment.format('DD/MM/YYYY');
		const weekDayNum = dayMoment.day(); // 0=domingo, 6=sábado

		if (weekDayNum === 0) return false; // domingo no
		if (closedSet[formatted]) return false;
		if (closedWeekdays.has(weekDayNum)) return false;

		return true;
	};

	const addPickupDays = (fromDate, pickupDays) => {
		let d = fromDate.clone();
		let added = 0;
		while (added < pickupDays) {
			d.add(1, 'day');
			if (isPickupOpenDay(d)) {
				added++;
			}
		}
		return d;
	};

	const getCutoffHour = (dayMoment) => (dayMoment.day() === 6 ? 12 : 14);

	const now = moment();
	const orderDay = now.clone().startOf('day');

	let firstPickupDay;
	if (isPickupOpenDay(orderDay) && now.hour() < getCutoffHour(orderDay)) {
		firstPickupDay = orderDay.clone();
	} else {
		firstPickupDay = addPickupDays(orderDay, 1);
	}

	const days = [];
	let current = firstPickupDay.clone();
	while (days.length < count) {
		if (!isPickupOpenDay(current)) {
			current = addPickupDays(current, 1);
			continue;
		}
		days.push(current.format('DD/MM/YYYY'));
		current.add(1, 'day');
	}

	return days;
};
